export class PriceRange {
    id: number;
    name: string;
    fromValue: number;
    toValue: number;
}